import { render } from "./socialNetworksData.vue?vue&type=template&id=328dfd8a&ts=true"
import script from "./socialNetworksData.vue?vue&type=script&lang=ts"
export * from "./socialNetworksData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__